import React from 'react';
import NavDrawer from './Drawers/NavDrawer';

export default () => [
  <NavDrawer key="nav-drawer" />,
];
